import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    successMessage: null,
    errorMessage: null,
    percentage: 0,
    loading: false
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setSuccessMessage (state, payload) {
      state.successMessage = payload
    },
    setErrorMessage (state, payload) {
      state.errorMessage = payload
    },
    setPercentage (state, payload) {
      state.percentage = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    }
  },
  actions: {
    userChanged ({ commit }, payload) {
      commit('setUser', payload)
    },
    logout ({ commit }) {
      firebase.auth().signOut()
    },
    verificarEmail ({ commit }, payload) {
      commit('setPercentage', 50)
      firebase.auth().applyActionCode(payload).then(() => {
        commit('setPercentage', 100)
      }).catch(() => {
        commit('setErrorMessage', 'O código está inválido ou expirado, por favor, solicite um novo e-mail de confirmação.')
        firebase.auth.sendPasswordResetEmail()
      })
    },
    validarCodigoSenha ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        firebase.auth().verifyPasswordResetCode(payload).then(email => {
          let user = { email: email }
          commit('setUser', user)
          resolve(user)
        }).catch((error) => {
          commit('setErrorMessage', 'O código do seu e-mail está expirado ou inválido, por favor, tente novamente.')
          reject(error)
        })
      })
    },
    resetarSenha ({ commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        firebase.auth().confirmPasswordReset(payload.actionCode, payload.password).then((response) => {
          commit('setLoading', false)
          resolve(response)
        }).catch(error => {
          commit('setLoading', false)
          commit('setErrorMessage', 'A senha inseria é muito fraca, por favor, tente novamente.')
          reject(error)
        })
      })
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    successMessage (state) {
      return state.successMessage
    },
    errorMessage (state) {
      return state.errorMessage
    },
    percentage (state) {
      return state.percentage
    },
    loading (state) {
      return state.loading
    }
  }
})
